import React, { useMemo } from "react";
import Joyride, { CallBackProps, Step } from "react-joyride";
import { useTour } from "@/hooks/useTour";
import { TourTooltip } from "./TourTooltip";

export const GuidedTour: React.FC = () => {
	const tour = useTour();

	const joyrideSteps: Step[] = useMemo(
		() =>
			tour.steps.map((s) => ({
				target: tour.resolveStepTarget(s),
				content: "",
				placement: s.placement,
				disableBeacon: s.disableBeacon ?? true,
			})),
		[tour.steps, tour.resolveStepTarget],
	);

	const handleCallback = (_data: CallBackProps) => {
		// Controlled mode — all transitions are driven by the custom tooltip
		// calling tour.next / tour.prev / tour.skip / tour.finish directly.
		// We ignore Joyride's own status/action machinery, which otherwise
		// spuriously fires FINISHED when `run` flips to false during cross-route
		// navigation and would end the tour.
	};

	if (!tour.run) return null;

	return (
		<Joyride
			key={`tour-step-${tour.stepIndex}`}
			steps={joyrideSteps}
			run={true}
			stepIndex={tour.stepIndex}
			continuous
			showSkipButton
			disableOverlayClose
			disableCloseOnEsc
			disableScrolling={false}
			scrollToFirstStep
			spotlightPadding={6}
			tooltipComponent={TourTooltip}
			callback={handleCallback}
			styles={{
				options: {
					zIndex: 45,
					overlayColor: "rgba(0,0,0,0.55)",
					primaryColor: "#5a7ebf",
					arrowColor: "var(--card, #fff)",
				},
				spotlight: {
					borderRadius: 8,
				},
			}}
		/>
	);
};
